var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .25C7.302.25.25 7.302.25 16S7.302 31.75 16 31.75 31.75 24.698 31.75 16 24.698.25 16 .25Zm0 28.828C8.779 29.078 2.922 23.221 2.922 16 2.922 8.779 8.779 2.922 16 2.922c7.221 0 13.078 5.857 13.078 13.078 0 7.221-5.857 13.078-13.078 13.078Z",
    fill: "#047CEB"
  })));
};

export default SvgInfo;